// src/services/CustomerReviewService.js
import api from "./api";

export function getCustomerReview(page = 1, limit = 10, search = "") {
  return api.get(
    `/customerreview?page=${page}&limit=${limit}&search=${search}`
  );
}

export function getCustomerReviewById(id) {
  return api.get(`/customerreview/${id}`);
}

export function addCustomerReview(data) {
  return api.post("/customerreview", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function updateCustomerReview(id, data) {
  return api.put(`/customerreview/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function deleteCustomerReview(id) {
  return api.delete(`/customerreview/${id}`);
}
